import { Autocomplete, CircularProgress, InputAdornment, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAllStudents } from "store/lookup";

export default function StudentSearchBar({
  onSelect = () => { },
  label = 'Select Student',
  size = 'small',
  value = null,
  disabled = false,
  gradeLevelId = null,
  gradeSectionId = null
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { academicYear } = useSelector(state => state.session);
  const allStudents = useSelector(state => state.lookup.allStudents.rows);
  const [activeOnly, setActiveOnly] = useState(true)

  useEffect(() => {
    allStudents || dispatch(getAllStudents({ limit: 1000 }))
  }, [academicYear, Boolean(allStudents)])

  const loading = !allStudents
  const filteredStudents = (allStudents ?? []).filter(
    s =>
      s.isActive === activeOnly &&
      (!gradeSectionId || s.academicYearEnrollment?.gradeSectionId === gradeSectionId) &&
      (!gradeLevelId || String(s.academicYearEnrollment?.gradeLevelId) === String(gradeLevelId)),
  )

  return (
    <Autocomplete
      disablePortal
      fullWidth
      size={size}
      options={filteredStudents}
      value={value}
      loading={loading}
      onChange={(_, v) => onSelect(v)}
      getOptionLabel={option => `${option?.person?.lastName}, ${option?.person?.firstName}`}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          label={t(label)}
          disabled={disabled}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <ToggleButtonGroup
                  value={activeOnly}
                  exclusive
                  size="small"
                  onChange={(_, val) => { if (val !== null) { setActiveOnly(val); onSelect(null) } }}
                  onClick={e => e.stopPropagation()}
                  sx={{ mr: 0.5, '& .MuiToggleButton-root': { py: 0.25, px: 1, fontSize: 10, border: 'none', borderRadius: '12px !important' } }}
                >
                  <ToggleButton value={true} color="success">{t('Active')}</ToggleButton>
                  <ToggleButton value={false} color="error">{t('Inactive')}</ToggleButton>
                </ToggleButtonGroup>
              </InputAdornment>
            ),
            endAdornment: (
              <>
                {loading && <CircularProgress size={16} sx={{ mr: 1 }} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      disabled={disabled}
    />
  );
}
